module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Dancer-Web-640.45eb7ed6.jpg";